import { axios } from '@/utils/request'

const api = {
  gbookList: '/adminapi/gbook/gbookList',
  gbookEdit: '/adminapi/gbook/gbookEdit',
}

export default api
//获取咨询列表
export function gbookList(parameter) {
  return axios({
    url: api.gbookList,
    method: 'get',
    params: parameter
  })
}
//处理咨询
export function gbookEdit(parameter) {
  return axios({
    url: api.gbookEdit,
    method: 'post',
    params: parameter
  })
}